<template>
  <div class="font_1">
    <el-icon><Message /></el-icon>公 告
  </div>
  <div class="font_2" v-if="course">
    <p style="white-space: pre-line;" v-html="course.notices"></p>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import $ from 'jquery';

const Route = useRoute(); //获取到值
const courseId = ref("");
let course = ref(null);


onMounted(() => {
  courseId.value = Route.params.courseId;
  pullCourse(courseId.value);
});


const pullCourse = (id) => {
    $.ajax({
    url: "http://124.222.105.205:5000/get/api/course/getCourseById",
    data: {
        courseId: id
    },
    type: "post",
    success(resp) {
      course.value = resp.data;

      if (resp.code != "200") {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }
    },
    error() {
        ElMessage({
          type: "error",
          message: "获取课程失败",
        });
    },
  });
}
</script>

<style scoped>
.font_1 {
    font-weight: bold;
    font-size: 30px;
}

.font_2 {
    font-size: 20px;
    color: rgb(85, 85, 85);
}

</style>